export const SET_VOLUME = "SET_VOLUME";
export const PLAY = "PLAY";
export const STOP = "STOP";
